import { Route, Routes } from 'react-router-dom';
import DashboardLayout from '@/layouts/dashboard';
import AuthGuard from '@/guards/AuthGuard';
import RoleBasedGuard from '@/guards/RoleBasedGuard';

import { PATH_ROLES } from './paths';
import { RoleCreateEdit, RolesList } from '../pages';

const ROLES_AND_PERMISSIONS_ROUTES = [
  {
    path: '',
    roles: ['roles_permissions.view'],
    component: <RolesList />,
    index: true,
  },
  {
    path: PATH_ROLES.new,
    roles: ['roles_permissions.create'],
    component: <RoleCreateEdit />,
    index: false,
  },
  {
    path: PATH_ROLES.edit,
    roles: ['roles_permissions.update'],
    component: <RoleCreateEdit />,
    index: false,
  },
];

export const RolesRoutes = () => (
  <Routes>
    <Route
      element={
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      }
    >
      {ROLES_AND_PERMISSIONS_ROUTES.map((route, index) => (
        <Route
          key={index}
          path={route.path}
          index={route.index}
          element={
            <RoleBasedGuard roles={route.roles}>
              {route.component}
            </RoleBasedGuard>
          }
        />
      ))}
    </Route>
  </Routes>
);
